/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { getJson } from 'session';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DragAndDrop from 'modules/common/components/DragAndDrop';
import { Acl } from 'modules/common/components/Acl';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import useFormValidator from 'useFormValidator';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import CmsContext from 'context/CmsContext';
import { ModalContext } from 'App';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import Address from 'modules/common/address/Address';
import Citizenship from 'modules/BPLS/applications/components/Citizenship';
import * as c from '../constant';
import * as actions from '../action';

function BusinessModal({
  createNewBusinesses,
  getNewBusinessesList,
  history,
  id,
  getSingleNewBusinesses,

  creating,
  ordinanceRevisionId,
  createUploader,
  getVeterinaryFeeList,
  veterinaryFeeList,
  type,
  newBusinessesInfo,
  updateNewBusinesses,
  updating,
}) {
  const permissions = getJson('permissions');
  const [formData, setFormData] = useState({
    id: '',
    business_name: '',
    trade_name: '',
    cellphone_no: '',
    telephone_no: '',
    email_address: '',
    nationality: '',
    tin_no: '',
    kind_of_ownership: '',
    cda_no: '',
    dti_no: '',
    sec_no: '',

    main_office_region_code: '130000000',
    main_office_province_code: '133900000',
    main_office_municipality_code: '',
    main_office_barangay_code: '',
    main_office_street: '',
    main_office_zip_code: '',

    area: '',
    base_line: '',
    no_of_employees: '',
    no_of_employees_residing_manila: '',
    no_of_male_employees: '',
    no_of_female_employees: '',
    no_of_vehicles: '',
    no_of_van: '',
    no_of_truck: '',
    no_of_motorcycle: '',

    incharge_first_name: '',
    incharge_last_name: '',
    incharge_middle_name: '',
    incharge_suffix_name: '',
    owners_gender: '',

    region_code: '130000000',
    province_code: '133900000',
    municipality_code: '',
    barangay_code: '',
    street: '',
    zip_code: '',
    location_owned: 0,
    tdn_no: '',
    pin_no: '',
    monthly_rental: '',
    with_tax_incentives: '',
    tax_incentives_attachment_url: '',
    activity_type: '',
    lessor_name: '',
    pinned_geolocation: '14.5964957,120.9445404',
    veterinary_fee_id: '',
  });

  const [pinFormat, setPinFormat] = useState(false);

  let commonValidation = {
    kind_of_ownership: 'required',
    owners_gender:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=SOLE PROPRIETORSHIP',
    business_name: 'required',
    // tin_no: 'required|tin_no',

    // dti_no: 'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|dti_no',
    // sec_no: 'required_if:kind_of_ownership=CORPORATION|sec_no',
    // cda_no: 'required_if:kind_of_ownership=COOPERATIVE|cda_no',

    dti_no:
      'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|min_5_char|max_20_char',
    // sec_no: "required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|sec_no",
    sec_no:
      'required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|min_5_char|max_20_char',
    // cda_no: "required_if:kind_of_ownership=COOPERATIVE|cda_no",
    cda_no: 'required_if:kind_of_ownership=COOPERATIVE|min_5_char|max_20_char',

    cellphone_no: 'required|cellphone_number',
    // telephone_no: 'required|tel_number',
    email_address: 'required|email',
    municipality_code: 'required',
    barangay_code: 'required',
    street: 'required',
    zip_code: 'required|number',
    incharge_first_name: 'required',
    incharge_last_name: 'required',
    nationality:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|required_if:kind_of_ownership=CORPORATION',
    area: 'required|number',
    base_line: 'required|number',
    no_of_male_employees: 'required|number',
    no_of_female_employees: 'required|number',
    // no_of_employees: 'required|number',
    no_of_employees_residing_manila: 'required|number',
    no_of_van: 'required|number',
    no_of_truck: 'required|number',
    no_of_motorcycle: 'required|number',
    main_office_municipality_code: 'required',
    main_office_barangay_code: 'required',
    main_office_street: 'required',
    main_office_zip_code: 'required|number',

    // tdn_no: "required_if:tdn_selected=1|rptax_tdn",
    // pin_no: "required_if:pin_selected=1|rptax_pin",
    tdn_no: 'required_if:tdn_selected=1',
    pin_no: 'required_if:pin_selected=1',
    lessor_name: 'required_if:location_owned=0',
    // monthly_rental: "required_if:location_owned=0|number|min_3_digits",
    monthly_rental: 'required_if:location_owned=0',
    with_tax_incentives: 'required',
    tax_incentives_attachment_url: 'required_if:with_tax_incentives=1',
    activity_type: 'required',
  };

  const validateForm = useFormValidator(formData, commonValidation);

  useEffect(() => {
    if (_.get(formData, 'location_owned') === 1) {
      if (_.get(formData, 'pin_selected') === 0) {
        commonValidation = {
          ...commonValidation,
          tdn_no: 'required|rptax_tdn',
        };
      }
      if (_.get(formData, 'pin_selected') === 1) {
        commonValidation = {
          ...commonValidation,
          pin_no: pinFormat ? 'required|rptax_pin' : 'required|rptax_pin_short',
        };
      }
    }

    validateForm.onSetObjectRules(commonValidation);
  }, [
    _.get(formData, 'location_owned'),
    _.get(formData, 'pin_selected'),
    pinFormat,
  ]);

  // const validateForm = useFormValidator(formData, {
  //   cellphone_no: 'required|cellphone_number',
  //   telephone_no: 'tel_number',
  //   email_address: 'required|email',
  //   nationality:
  //     'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|required_if:kind_of_ownership=CORPORATION',
  //   tin_no: 'required|tin_no',
  //   kind_of_ownership: 'required',
  //   dti_no: 'required_if:kind_of_ownership=SOLE PROPRIETORSHIP',
  //   sec_no:
  //     'required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|required_if:kind_of_ownership=ONE PERSON CORPORATION',
  //   cda_no: 'required_if:kind_of_ownership=COOPERATIVE',
  //   main_office_region_code: 'required',
  //   main_office_province_code: 'required',
  //   main_office_municipality_code: 'required',
  //   main_office_barangay_code: 'required',
  //   main_office_street: 'required',
  //   main_office_zip_code: 'required|zip_code',
  //   area: 'required',
  //   base_line: 'required',
  //   no_of_employees_residing_manila: 'required|number',
  //   no_of_male_employees: 'required|number',
  //   no_of_female_employees: 'required|number',
  //   no_of_van: 'required',
  //   no_of_truck: 'required',
  //   no_of_motorcycle: 'required',
  //   incharge_first_name: 'required',
  //   incharge_last_name: 'required',
  //   incharge_middle_name: 'required',
  //   owners_gender:
  //     'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=SOLE PROPRIETORSHIP',
  //   region_code: 'required',
  //   province_code: 'required',
  //   municipality_code: 'required',
  //   with_tax_incentives: 'required',
  //   barangay_code: 'required',
  //   street: 'required',
  //   zip_code: 'required|zip_code',
  //   // tdn_no: "required_if:is_tdn_selected=1|tdn_no",
  //   // pin_no: "required_if:is_pin_selected=1|pin_no",
  //   monthly_rental: 'required',
  //   lessor_name: 'required_if:location_owned=0'
  //   // veterinary_fee_id: 'required',
  // },
  // {
  //   owners_gender: { generic_message: 'Required' },
  //   dti_no: { generic_message: 'Required' },
  //   sec_no: { generic_message: 'Required' },
  //   nationality: { generic_message: 'Required' },
  //   lessor_name: { generic_message: 'Required' },
  // });
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_MASKINGS = cmsContext.findByType('MASKINGS');

  const setModal = useContext(ModalContext);

  useEffect(() => {
    getVeterinaryFeeList();
  }, []);

  const disableOwnersGender = (data) => {
    if (_.isEmpty(data)) {
      return true;
    }
    if (['PARTNERSHIP', 'CORPORATION', 'COOPERATIVE'].indexOf(data) <= -1) {
      return false;
    }
    return true;
  };

  const findGenderValue =
    ['PARTNERSHIP', 'CORPORATION', 'COOPERATIVE'].indexOf(
      _.get(formData, 'kind_of_ownership')
    ) > -1
      ? ''
      : c.OWNERS_GENDER.find(
          (item) => _.get(formData, 'owners_gender') === _.get(item, 'value')
        ) || '';

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...formData,
      dti_no: _.get(formData, 'dti_no').toUpperCase(),
      sec_no: _.get(formData, 'sec_no').toUpperCase(),
      ordinance_revision_id: ordinanceRevisionId,
    };

    if (type === 'NEW') {
      createNewBusinesses(args, ({ data }) => {
        setModal({ isOpen: false });
        getNewBusinessesList({ ordinance_revision_id: ordinanceRevisionId });
        history.push(`/bpls/new-business/new-businesses/${_.get(data, 'id')}`);
        getSingleNewBusinesses(data.id);
      });
    }
    return updateNewBusinesses(id, args, ({ data }) => {
      setModal({ isOpen: false });
      getNewBusinessesList({ ordinance_revision_id: ordinanceRevisionId });
      history.push(`/bpls/new-business/new-businesses/${_.get(data, 'id')}`);
      getSingleNewBusinesses(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChangeRadioLocationOwned = (e) => {
    if (e.target.name === 'location_owned' && e.target.value === '1') {
      setFormData({
        ...formData,
        [e.target.name]: +e.target.value,
        lessor_name: '',
        monthly_rental: '',
        tdn_selected: 1,
      });
    }

    if (e.target.name === 'location_owned' && e.target.value === '0') {
      // if (!e.target.checked) {
      setFormData({
        ...formData,
        [e.target.name]: +e.target.value,
        pin_no: '',
        tdn_no: '',
        pin_selected: 0,
        tdn_selected: 0,
      });
    }

    return false;
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const onChangeRadio = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: +e.target.value,
    });
  };

  const onChangeCheckbox = (e) => {
    if (e.target.name === 'pin_selected') {
      if (e.target.checked) {
        setFormData((prevForm) => ({
          ...prevForm,
          tdn_no: '',
          pin_selected: 1,
          tdn_selected: 0,
        }));
      }

      if (!e.target.checked) {
        setFormData((prevForm) => ({
          ...prevForm,
          pin_no: '',
          pin_selected: 0,
          tdn_selected: 1,
        }));
      }
    }
    if (e.target.name === 'is_override_employee_min') {
      setFormData({
        ...formData,
        [e.target.name]: e.target.checked,
      });
    }
  };

  const onChangePhoto = (key) => (data) => {
    setFormData({
      ...formData,
      [key]: data.cdnUrl,
    });
  };

  const handleOnChangeRadio = (e) => {
    if (e.target.value !== 'others') {
      setFormData({
        ...formData,
        activity_type: e.target.value,
        activity_type_others: '',
      });
    }
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    if (!_.isEmpty(newBusinessesInfo)) {
      const checkNumberOfEmployees = (employeesData) => {
        if (
          _.get(newBusinessesInfo, 'attributes.no_of_employees') === 0 ||
          _.get(newBusinessesInfo, 'attributes.no_of_employees') === '0'
        )
          return '0';
        if (
          _.get(newBusinessesInfo, 'attributes.no_of_employees') !== 0 ||
          _.get(newBusinessesInfo, 'attributes.no_of_employees') !== '0'
        ) {
          if (
            (employeesData === 0 || employeesData === '0') &&
            (_.get(newBusinessesInfo, 'attributes.no_of_male_employees') !==
              0 ||
              _.get(newBusinessesInfo, 'attributes.no_of_female_employees') !==
                0)
          )
            return '0';
          if (
            (employeesData === 0 || employeesData === '0') &&
            (_.get(newBusinessesInfo, 'attributes.no_of_male_employees') ===
              0 ||
              _.get(newBusinessesInfo, 'attributes.no_of_female_employees') ===
                0)
          )
            return '';
        }
        return employeesData;
      };

      if (!_.isEmpty(newBusinessesInfo)) {
        // const business = _.get(updateList, 'included.bplsBusiness.attributes');
        const business = _.get(newBusinessesInfo, 'attributes');

        const pinNo = _.get(business, 'pin_no')
          ? _.get(business, 'pin_no').replace(/-/g, '')
          : '';
        const DEFAULT_PIN_LENGTH = 14;
        if (pinNo.length > DEFAULT_PIN_LENGTH) {
          setPinFormat(true);
        }
        if (pinNo.length < DEFAULT_PIN_LENGTH) {
          setPinFormat(false);
        }
      }

      setFormData({
        ...formData,
        ..._.get(newBusinessesInfo, 'attributes.details'),
        business_name:
          _.get(newBusinessesInfo, 'attributes.business_name') || '',
        email_address:
          _.get(newBusinessesInfo, 'attributes.email_address') || '',
        bin: _.get(newBusinessesInfo, 'attributes.bin') || '',
        taxpayer_id: _.get(newBusinessesInfo, 'attributes.taxpayer_id') || '',
        cellphone_no: _.get(newBusinessesInfo, 'attributes.cellphone_no') || '',
        telephone_no: _.get(newBusinessesInfo, 'attributes.telephone_no') || '',
        tin_no: _.get(newBusinessesInfo, 'attributes.tin_no') || '',
        dti_no: _.get(newBusinessesInfo, 'attributes.dti_no') || '',
        sec_no: _.get(newBusinessesInfo, 'attributes.sec_no') || '',
        cda_no: _.get(newBusinessesInfo, 'attributes.cda_no') || '',
        kind_of_ownership:
          _.get(newBusinessesInfo, 'attributes.kind_of_ownership') || '',
        region_code: _.get(newBusinessesInfo, 'attributes.region_code') || '',
        province_code:
          _.get(newBusinessesInfo, 'attributes.province_code') || '',
        municipality_code:
          _.get(newBusinessesInfo, 'attributes.municipality_code') || '',
        barangay_code:
          _.get(newBusinessesInfo, 'attributes.barangay_code') || '',
        street: _.get(newBusinessesInfo, 'attributes.street') || '',
        zip_code: _.get(newBusinessesInfo, 'attributes.zip_code') || '',
        main_office_region_code:
          _.get(newBusinessesInfo, 'attributes.main_office_region_code') ||
          '130000000',
        main_office_province_code:
          _.get(newBusinessesInfo, 'attributes.main_office_province_code') ||
          '133900000',
        main_office_municipality_code:
          _.get(
            newBusinessesInfo,
            'attributes.main_office_municipality_code'
          ) || '',
        main_office_barangay_code:
          _.get(newBusinessesInfo, 'attributes.main_office_barangay_code') ||
          '',
        main_office_street:
          _.get(newBusinessesInfo, 'attributes.main_office_street') || '',
        main_office_zip_code:
          _.get(newBusinessesInfo, 'attributes.main_office_zip_code') || '',
        area: _.get(newBusinessesInfo, 'attributes.area') || '',

        no_of_employees:
          _.get(newBusinessesInfo, 'attributes.no_of_employees') === 0
            ? '0'
            : _.get(newBusinessesInfo, 'attributes.no_of_employees') || '',
        no_of_employees_residing_manila:
          checkNumberOfEmployees(
            _.get(
              newBusinessesInfo,
              'attributes.no_of_employees_residing_manila'
            )
          ) || '',
        no_of_male_employees:
          _.get(newBusinessesInfo, 'attributes.no_of_employees') === 0
            ? '0'
            : _.get(newBusinessesInfo, 'attributes.no_of_male_employees') ||
              '0',
        no_of_female_employees:
          _.get(newBusinessesInfo, 'attributes.no_of_employees') === 0
            ? '0'
            : _.get(newBusinessesInfo, 'attributes.no_of_female_employees') ||
              '0',
        no_of_vehicles:
          _.get(newBusinessesInfo, 'attributes.no_of_vehicles') || '0',
        no_of_van: _.get(newBusinessesInfo, 'attributes.no_of_van') || '0',
        no_of_truck: _.get(newBusinessesInfo, 'attributes.no_of_truck') || '0',
        no_of_motorcycle:
          _.get(newBusinessesInfo, 'attributes.no_of_motorcycle') || '0',
        incharge_first_name:
          _.get(newBusinessesInfo, 'attributes.incharge_first_name') || '',
        incharge_last_name:
          _.get(newBusinessesInfo, 'attributes.incharge_last_name') || '',
        incharge_middle_name:
          _.get(newBusinessesInfo, 'attributes.incharge_middle_name') || '',
        incharge_suffix_name:
          _.get(newBusinessesInfo, 'attributes.incharge_suffix_name') || '',
        owners_gender:
          _.get(newBusinessesInfo, 'attributes.owners_gender') || '',
        trade_name: _.get(newBusinessesInfo, 'attributes.trade_name') || '',
        nationality: _.get(newBusinessesInfo, 'attributes.nationality') || '',
        monthly_rental:
          _.get(newBusinessesInfo, 'attributes.monthly_rental', '') || '',
        lessor_name: _.get(newBusinessesInfo, 'attributes.lessor_name') || '',
        location_owned:
          _.get(newBusinessesInfo, 'attributes.location_owned') || 0,
        tdn_no: _.get(newBusinessesInfo, 'attributes.tdn_no') || '',
        pin_no: _.get(newBusinessesInfo, 'attributes.pin_no') || '',
        pin_selected: !_.isEmpty(_.get(newBusinessesInfo, 'attributes.pin_no'))
          ? 1
          : 0,
        tdn_selected: !_.isEmpty(_.get(newBusinessesInfo, 'attributes.tdn_no'))
          ? 1
          : 0,
        tax_incentives_attachment_url:
          _.get(
            newBusinessesInfo,
            'attributes.tax_incentives_attachment_url'
          ) || '',
        activity_type:
          _.get(newBusinessesInfo, 'attributes.activity_type') || '',
        activity_type_others:
          _.get(newBusinessesInfo, 'attributes.activity_type_others') || '',
        base_line:
          _.get(newBusinessesInfo, 'attributes.base_line') === 0
            ? '0'
            : _.get(newBusinessesInfo, 'attributes.base_line') || '',
        with_tax_incentives:
          _.get(newBusinessesInfo, 'attributes.with_tax_incentives') || 0,
        veterinary_fee_id:
          _.get(newBusinessesInfo, 'attributes.veterinary_fee_id') || '',
      });
    }
  }, []);

  // vet reg filter dropdown
  const listOption =
    veterinaryFeeList.map((item) => ({
      label: _.get(item, 'attributes.veterinary_registration'),
      value: _.get(item, 'id'),
    })) || '';

  const addedData = {
    label: 'Select',
    value: '',
  };

  const sortOption = (listOption || []).concat([addedData]);
  const vetRegistrationListOption = _.orderBy(sortOption, ['value'], ['asc']);

  const handlePinFormat = (e) => {
    const pinNo = formData.pin_no.replace(/-/g, '');
    const DEFAULT_PIN_LENGTH = 14;

    if (e.target.checked) {
      setPinFormat(true);
    }

    if (!e.target.checked) {
      if (pinNo.length > DEFAULT_PIN_LENGTH) {
        const remainder = DEFAULT_PIN_LENGTH - pinNo.length; // return negative value
        const newPinNo = pinNo.slice(0, remainder); // remove excess pin_no if user switch to default format (after typing from 19 digit format)

        setFormData({
          ...formData,
          pin_no: newPinNo.replace(
            /(\d{3,3})(\d{2,2})(\d{3,3})(\d{3,3})(\d{3,3})$/,
            '$1-$2-$3-$4-$5'
          ), // format pin_no into (000-00-000-000-000)
        });
      }

      setPinFormat(false);
    }
  };

  const onChangeBusinessAddress = (e) => {
    setFormData({
      ...formData,
      main_office_region_code: e.target.value.region_code,
      main_office_province_code: e.target.value.province_code,
      main_office_municipality_code: e.target.value.municipality_code,
      main_office_barangay_code: e.target.value.barangay_code,
      main_office_street: e.target.value.street || '',
    });
  };

  const onChangeTaxPayerAddress = (e) => {
    setFormData({
      ...formData,
      region_code: e.target.value.region_code,
      province_code: e.target.value.province_code,
      municipality_code: e.target.value.municipality_code,
      barangay_code: e.target.value.barangay_code,
      street: e.target.value.street || '',
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Information and Registration
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Kind of Ownership:
                {validateForm.renderMessage('kind_of_ownership')}
              </label>
              <Select
                name="kind_of_ownership"
                placeholder="Select Module"
                onChange={handleOnChangeSelect('kind_of_ownership')}
                options={c.KIND_OF_OWNERSHIP}
                value={
                  c.KIND_OF_OWNERSHIP.find(
                    (item) =>
                      _.get(formData, 'kind_of_ownership') ===
                      _.get(item, 'value')
                  ) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Owners Gender: {validateForm.renderMessage('owners_gender')}
              </label>
              <Select
                isDisabled={disableOwnersGender(
                  _.get(formData, 'kind_of_ownership')
                )}
                isClearable
                name="owners_gender"
                placeholder="Select Gender"
                onChange={handleOnChangeSelect('owners_gender')}
                options={c.OWNERS_GENDER}
                value={findGenderValue}
              />
            </div>
            {formData.kind_of_ownership === 'SOLE PROPRIETORSHIP' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  DTI Registration Number:{' '}
                  {validateForm.renderMessage('dti_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="dti_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'dti_no') || ''}
                />
              </div>
            )}
            {(formData.kind_of_ownership === 'CORPORATION' ||
              formData.kind_of_ownership === 'PARTNERSHIP' ||
              formData.kind_of_ownership === 'ONE PERSON CORPORATION') && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  SEC Registration Number:{' '}
                  {validateForm.renderMessage('sec_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="sec_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'sec_no') || ''}
                />
              </div>
            )}
            {formData.kind_of_ownership === 'COOPERATIVE' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  CDA Registration Number:{' '}
                  {validateForm.renderMessage('cda_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="cda_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'cda_no') || ''}
                />
              </div>
            )}
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Tax Identification Number:{' '}
                {validateForm.renderMessage('tin_no')}
              </label>
              <InputMask
                className="form-control"
                mask="999-999-999-999"
                alwaysShowMask
                type="text"
                name="tin_no"
                onChange={onChange}
                value={_.get(formData, 'tin_no')}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Name:{' '}
                {validateForm.renderMessage('business_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="business_name"
                onChange={onChange}
                value={_.get(formData, 'business_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Trade Name / Franchise (If Applicable) :
              </label>
              <input
                className="form-control"
                type="text"
                name="trade_name"
                onChange={onChange}
                value={_.get(formData, 'trade_name') || ''}
              />
            </div>
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          {`${
            ['ONE PERSON CORPORATION', 'PARTNERSHIP', 'CORPORATION'].indexOf(
              _.get(formData, 'kind_of_ownership')
            ) > -1
              ? "President's Name/ Officer in Charge"
              : "Owner's Name"
          } `}
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Last Name: {validateForm.renderMessage('incharge_last_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="incharge_last_name"
                onChange={onChange}
                value={_.get(formData, 'incharge_last_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                First Name: {validateForm.renderMessage('incharge_first_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="incharge_first_name"
                onChange={onChange}
                value={_.get(formData, 'incharge_first_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Middle Name:{' '}
                {validateForm.renderMessage('incharge_middle_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="incharge_middle_name"
                onChange={onChange}
                value={_.get(formData, 'incharge_middle_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Suffix Name:
              </label>
              <Select
                name="incharge_suffix_name"
                placeholder="Select Module"
                onChange={handleOnChangeSelect('incharge_suffix_name')}
                options={c.EXTENSION_NAMES}
                value={
                  c.EXTENSION_NAMES.find(
                    (item) =>
                      _.get(formData, 'incharge_suffix_name') ===
                      _.get(item, 'value')
                  ) || ''
                }
              />
            </div>
            {(formData.kind_of_ownership === 'CORPORATION' ||
              formData.kind_of_ownership === 'ONE PERSON CORPORATION' ||
              formData.kind_of_ownership === 'PARTNERSHIP') && (
              <div className="col-6 form-group">
                <label className="form-label mb-0">
                  Nationality: {validateForm.renderMessage('nationality')}
                </label>
                <Citizenship
                  name="nationality"
                  onChange={onChange}
                  value={_.get(formData, 'nationality') || ''}
                />
              </div>
            )}
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Contact Information
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Email Address: {validateForm.renderMessage('email_address')}
              </label>
              <input
                className="form-control"
                type="text"
                name="email_address"
                onChange={onChange}
                value={_.get(formData, 'email_address') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Mobile Number: {validateForm.renderMessage('cellphone_no')}
              </label>
              <InputMask
                className="form-control"
                mask="639999999999"
                alwaysShowMask
                type="text"
                name="cellphone_no"
                onChange={onChange}
                value={_.get(formData, 'cellphone_no')}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Telephone Number:
              </label>
              <InputMask
                className="form-control"
                // mask="99-9999-9999"
                // alwaysShowMask
                type="text"
                name="telephone_no"
                onChange={onChange}
                value={_.get(formData, 'telephone_no')}
              />
            </div>
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Address
        </div>
        <div className="container-fluid">
          {_.get(CMS_COMPONENTS, 'BUSINESS_ADDRESS') && (
            <Address
              required
              value={{
                region_code: _.get(formData, 'main_office_region_code') || '',
                province_code:
                  _.get(formData, 'main_office_province_code') || '',
                municipality_code:
                  _.get(formData, 'main_office_municipality_code') || '',
                barangay_code:
                  _.get(formData, 'main_office_barangay_code') || '',
              }}
              type="Business"
              onChange={onChangeBusinessAddress}
              region_name="main_office_region_code"
              province_name="main_office_province_code"
              municipality_name="main_office_municipality_code"
              barangay_name="main_office_barangay_code"
              name="main_office"
              withStreet={false}
              validatorMessage={validateForm.renderMessage}
              removeLabel
            />
          )}
          {!_.get(CMS_COMPONENTS, 'BUSINESS_ADDRESS') && (
            <Address
              required
              value={{
                region_code: _.get(formData, 'main_office_region_code') || '',
                province_code:
                  _.get(formData, 'main_office_province_code') || '',
                municipality_code:
                  _.get(formData, 'main_office_municipality_code') || '',
                barangay_code:
                  _.get(formData, 'main_office_barangay_code') || '',
              }}
              onChange={onChangeBusinessAddress}
              region_name="main_office_region_code"
              province_name="main_office_province_code"
              municipality_name="main_office_municipality_code"
              barangay_name="main_office_barangay_code"
              name="main_office"
              withStreet={false}
              validatorMessage={validateForm.renderMessage}
              removeLabel
            />
          )}
          <div className="row mt-2">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Unit/Room No./Floor, Building Name, House No., Street Name:{' '}
                {validateForm.renderMessage('main_office_street')}
              </label>
              <input
                className="form-control"
                type="text"
                name="main_office_street"
                onChange={onChange}
                value={_.get(formData, 'main_office_street') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                ZIP Code: {validateForm.renderMessage('main_office_zip_code')}
              </label>
              <InputMask
                className="form-control"
                type="text"
                mask="9999"
                name="main_office_zip_code"
                onChange={onChange}
                value={_.get(formData, 'main_office_zip_code') || ''}
              />
            </div>
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Operations
        </div>
        <div className="container-fluid">
          <div className="row">
            {Acl(permissions, ['E2E BPLS OVERRIDE EMPLOYEE MIN']) &&
              type === 'EDIT' && (
                <>
                  <div className="col-6 ml-auto">
                    <label htmlFor="last_name" className="form-label">
                      Manual Override: Minimum Employee Count &nbsp;
                    </label>
                    <input
                      name="is_override_employee_min"
                      type="checkbox"
                      checked={_.get(formData, 'is_override_employee_min')}
                      onChange={onChangeCheckbox}
                    />
                  </div>
                  <div className="col-6" />
                </>
              )}
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Area/Total Floor Area (sq.m):{' '}
                {validateForm.renderMessage('area')}
              </label>
              <input
                className="form-control"
                type="number"
                name="area"
                onChange={onChange}
                value={_.get(formData, 'area') || ''}
                required
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Employees residing within Manila:{' '}
                {validateForm.renderMessage('no_of_employees_residing_manila')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_employees_residing_manila"
                onChange={onChange}
                value={_.get(formData, 'no_of_employees_residing_manila') || ''}
                required
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Total No. of Male Employees:{' '}
                {validateForm.renderMessage('no_of_male_employees')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_male_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_male_employees') || ''}
                required
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Total No. of Female Employees:{' '}
                {validateForm.renderMessage('no_of_female_employees')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_female_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_female_employees') || ''}
                required
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Van Delivery Vehicles (if applicable):{' '}
                {validateForm.renderMessage('no_of_van')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_van"
                onChange={onChange}
                value={_.get(formData, 'no_of_van') || ''}
                required
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Truck Delivery Vehicles (if applicable):{' '}
                {validateForm.renderMessage('no_of_truck')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_truck"
                onChange={onChange}
                value={_.get(formData, 'no_of_truck') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Motorcycle Delivery Vehicles (If applicable):{' '}
                {validateForm.renderMessage('no_of_motorcycle')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_motorcycle"
                onChange={onChange}
                value={_.get(formData, 'no_of_motorcycle') || ''}
              />
            </div>
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Taxpayer&apos;s Address
        </div>
        <div className="container-fluid">
          <Address
            required
            value={{
              region_code: _.get(formData, 'region_code') || '',
              province_code: _.get(formData, 'province_code') || '',
              municipality_code: _.get(formData, 'municipality_code') || '',
              barangay_code: _.get(formData, 'barangay_code') || '',
            }}
            onChange={onChangeTaxPayerAddress}
            region_name="region_code"
            province_name="province_code"
            municipality_name="municipality_code"
            barangay_name="barangay_code"
            name="tax_payer_address"
            withStreet={false}
            validatorMessage={validateForm.renderMessage}
            removeLabel
          />
          <div className="row mt-2">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Unit/Room No./Floor, Building Name, House No., Street Name:{' '}
                {validateForm.renderMessage('street')}
              </label>
              <input
                className="form-control"
                type="text"
                name="street"
                onChange={onChange}
                value={_.get(formData, 'street') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                ZIP Code: {validateForm.renderMessage('zip_code')}
              </label>
              <InputMask
                className="form-control"
                type="text"
                mask="9999"
                name="zip_code"
                onChange={onChange}
                value={_.get(formData, 'zip_code') || ''}
              />
            </div>
          </div>
          <div className="col-6 form-group mb-0 pb-0">
            <div className="d-flex flex-row align-items-center justify-content-between">
              <label htmlFor="last_name" className="form-label mr-2 mb-1">
                Owned?
              </label>
              <div className="d-flex flex-row justify-content-center px-0 mx-0">
                <div className="d-flex align-items-center">
                  <input
                    type="radio"
                    name="location_owned"
                    style={{ width: '20px', height: '20px' }}
                    onChange={onChangeRadioLocationOwned}
                    checked={_.get(formData, 'location_owned') === 1}
                    value="1"
                  />
                  <label className="full-label mb-0 mx-1">Yes</label>
                </div>
                <div className="d-flex align-items-center mr-2">
                  <input
                    type="radio"
                    name="location_owned"
                    style={{ width: '20px', height: '20px' }}
                    onChange={onChangeRadioLocationOwned}
                    checked={_.get(formData, 'location_owned') === 0}
                    value="0"
                  />
                  <label className="full-label mb-0 mx-1">No</label>
                </div>
              </div>
            </div>
          </div>
          <div className="col-6 form-group" />{' '}
          {/* placeholder only to avoid collapsing of ONWED? input */}
          {formData.location_owned === 1 ? (
            <div className="col-6 form-group">
              <div className="row d-flex align-items-center justify-content-between">
                <div className="col-6">
                  <label className="form-label ">
                    {_.get(formData, 'pin_selected') !== 1
                      ? 'Tax Declaration No.'
                      : 'Property Identification No.'}{' '}
                    {_.get(formData, 'pin_selected') !== 1
                      ? validateForm.renderMessage('tdn_no')
                      : validateForm.renderMessage('pin_no')}
                  </label>
                </div>
                <div className="col-6 text-right">
                  {_.get(formData, 'pin_selected') ? (
                    <label className="form-label ">
                      19-digit Format:
                      <input
                        name="pinFormat"
                        type="checkbox"
                        checked={pinFormat}
                        onChange={handlePinFormat}
                        className="mx-2 mb-2"
                      />
                    </label>
                  ) : null}
                  <label className="form-label">PIN:</label>
                  {/* checkbox */}
                  <input
                    className="mx-2 mb-2"
                    type="checkbox"
                    name="pin_selected"
                    onChange={onChangeCheckbox}
                    checked={_.get(formData, 'pin_selected')}
                  />
                </div>
              </div>
              {/* input */}
              <InputMask
                className="form-control"
                placeholder={
                  /* eslint-disable no-nested-ternary */
                  _.get(formData, 'pin_selected')
                    ? pinFormat
                      ? _.get(CMS_MASKINGS, 'BPLS_E2E_PIN_19_DIGIT_PLACEHOLDER')
                      : _.get(CMS_MASKINGS, 'BPLS_E2E_PIN_PLACEHOLDER')
                    : _.get(CMS_MASKINGS, 'BPLS_E2E_TDN_PLACEHOLDER')
                }
                mask={
                  // temporary disabled
                  /* eslint-disable no-nested-ternary */
                  _.get(formData, 'pin_selected')
                    ? pinFormat
                      ? _.get(CMS_MASKINGS, 'BPLS_E2E_PIN_19_DIGIT')
                      : _.get(CMS_MASKINGS, 'BPLS_E2E_PIN')
                    : _.get(CMS_MASKINGS, 'BPLS_E2E_TDN')
                }
                alwaysShowMask
                maskChar=""
                type="text"
                name={
                  _.get(formData, 'pin_selected') !== 1 ? 'tdn_no' : 'pin_no'
                }
                id={_.get(formData, 'pin_selected') !== 1 ? 'tdn_no' : 'pin_no'}
                onChange={onChange}
                value={
                  _.get(formData, 'pin_selected') !== 1
                    ? _.get(formData, 'tdn_no', '')?.toUpperCase()
                    : _.get(formData, 'pin_no', '')?.toUpperCase() || ''
                }
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Lessor Name (if applicable):{' '}
                  {validateForm.renderMessage('lessor_name')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="lessor_name"
                  onChange={onChange}
                  value={_.get(formData, 'lessor_name') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="monthly_rental" className="form-label mb-0">
                  Monthly Rental: {validateForm.renderMessage('monthly_rental')}
                </label>
                <NumberFormat
                  name="monthly_rental"
                  id="monthly_rental"
                  placeholder=""
                  className="form-control"
                  onValueChange={(values) => {
                    const { floatValue, formattedValue } = values;
                    setFormData({
                      ...formData,
                      monthly_rental: floatValue || '0.00',
                    });
                  }}
                  displayType="input"
                  decimalScale={2}
                  decimalSeparator="."
                  fixedDecimalScale
                  isNumericString
                  allowNegative
                  thousandSeparator
                  allowLeadingZeros
                  prefix=""
                  value={
                    _.get(formData, 'monthly_rental', '')?.toString() || ''
                  }
                />
              </div>
            </div>
          )}
          {/* <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mr-2 mb-1">
              Owned? {validateForm.renderMessage('location_owned')}
            </label>
            <input
              type="radio"
              name="location_owned"
              onChange={onChangeRadio}
              checked={_.get(formData, 'location_owned') === 1}
              value="1"
            />
            <label className="form-label mx-2 mb-1">Yes</label>
            <input
              type="radio"
              name="location_owned"
              onChange={onChangeRadio}
              checked={_.get(formData, 'location_owned') === 0}
              value="0"
            />
            <label className="form-label mx-2 mb-1">No</label>
          </div> */}
          {/* {formData.location_owned === 1 ? (
            <div className="col-6 form-group py-2">
              <label className="col-10 form-label mb-1">
                {_.get(formData, 'pin_selected')
                  ? 'Property Identification No.'
                  : 'Tax Declaration No.'}
              </label>
              <label className="col-1 form-label align-items-center justify-content-end mb-1">
                Pin:
              </label>
              <input
                className=""
                type="checkbox"
                name="pin_selected"
                onChange={onChange}
                checked={_.get(formData, 'pin_selected')}
              />
              {_.get(formData, 'pin_selected') ? (
                <input
                  className="form-control"
                  type="text"
                  name="pin_no"
                  onChange={onChange}
                  value={_.get(formData, 'pin_no') || ''}
                />
              ) : (
                <input
                  className="form-control"
                  type="text"
                  name="tdn_no"
                  onChange={onChange}
                  value={_.get(formData, 'tdn_no') || ''}
                />
              )}
            </div>
          ) : (
            <>
              <div className="row">
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Lessor Name (if applicable):{' '}
                    {validateForm.renderMessage('lessor_name')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="lessor_name"
                    onChange={onChange}
                    value={_.get(formData, 'lessor_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Monthly Rental:{' '}
                    {validateForm.renderMessage('monthly_rental')}
                  </label>
                  <NumberFormat
                    name="monthly_rental"
                    id="monthly_rental"
                    placeholder="0"
                    className="form-control"
                    onValueChange={values => {
                      const { floatValue } = values;
                      setFormData({
                        ...formData,
                        monthly_rental: floatValue,
                      });
                    }}
                    isNumericString
                    thousandSeparator
                    allowNegative
                    allowLeadingZeros
                    displayType="input"
                    prefix=""
                    value={`${_.get(formData, 'monthly_rental', '')}` || ''}
                  />
                </div>
              </div>
            </>
          )} */}
          <div className="col-12 form-group py-2">
            <label htmlFor="last_name" className="form-label mr-2 mb-1">
              Tax Incentives from any Government Entity:{' '}
              {validateForm.renderMessage('with_tax_incentives')}
            </label>
            <input
              type="radio"
              name="with_tax_incentives"
              onChange={onChangeRadio}
              checked={_.get(formData, 'with_tax_incentives') === 1}
              value="1"
            />
            <label className="form-label mx-2 mb-1">Yes</label>
            <input
              type="radio"
              name="with_tax_incentives"
              onChange={onChangeRadio}
              checked={_.get(formData, 'with_tax_incentives') === 0}
              value="0"
            />
            <label className="form-label mx-2 mb-1">No</label>
          </div>
          {formData.with_tax_incentives === 1 ? (
            <div className="col-12 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Tax Incentive{' '}
                {validateForm.renderMessage('tax_incentives_attachment_url')}
              </label>
              <div className="row d-flex">
                <div className="col-3">
                  <div className="bg-primary pt-2 rounded text-center">
                    <label className="form-label text-white">Upload</label>
                  </div>
                </div>
                <div className="col-12 col-md-8">
                  <div className="form-wrapper p-2">
                    {!_.get(formData, 'tax_incentives_attachment_url') ? (
                      <DragAndDrop
                        onChange={onChangePhoto(
                          'tax_incentives_attachment_url'
                        )}
                        maxSize={2}
                        caption="JPEG. PNG. Maximum size 2MB."
                        label="Upload your Requirements here"
                        fileType="image/jpeg, image/jpg, image/png"
                      />
                    ) : (
                      <div className="bg-dark text-center py-2 pb-5 rounded">
                        <div className="d-flex justify-content-end col-1">
                          {createUploader(
                            {
                              key: 'tax_incentives_attachment_url',
                              label: 'Sketch',
                            },
                            { placeholder: '  ' }
                          )}
                        </div>
                        <img
                          src={
                            !_.isObject(
                              _.get(
                                formData,
                                'tax_incentives_attachment_url'
                              ) || ''
                            )
                              ? _.get(
                                  formData,
                                  'tax_incentives_attachment_url'
                                ) || ImagePlaceholder
                              : _.get(
                                  formData,
                                  'tax_incentives_attachment_url.cdnUrl'
                                ) || ImagePlaceholder
                          }
                          className="img-fluid shadow-lg"
                          role="presentation"
                          width="70%"
                          alt=""
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Calculation Details
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Veterinary Fee:{' '}
                {/* {validateForm.renderMessage('veterinary_fee_id')} */}
              </label>
              <Select
                options={vetRegistrationListOption}
                placeholder="Select Veterinary Fee"
                onChange={handleOnChangeSelect('veterinary_fee_id')}
                value={
                  vetRegistrationListOption.find((item) => {
                    return (
                      `${_.get(formData, 'veterinary_fee_id')}` ===
                      _.get(item, 'value')
                    );
                  }) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Base Line: {validateForm.renderMessage('base_line')}
              </label>
              <input
                className="form-control"
                type="text"
                name="base_line"
                onChange={onChange}
                value={_.get(formData, 'base_line') || ''}
              />
            </div>
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold my-2">
          Business Activities{' '}
          <span className="px-1">
            {validateForm.renderMessage('activity_type')}
          </span>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 form-group d-flex flex-row align-items-center justify-content-between px-3 py-2 my-0">
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'MAIN OFFICE'}
                value="MAIN OFFICE"
              />
              <label className="form-label pr-3 m-0">Main Office</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'BRANCH OFFICE'}
                value="BRANCH OFFICE"
              />
              <label className="form-label pr-3 m-0">Branch Office</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={
                  _.get(formData, 'activity_type') === 'ADMIN OFFICE ONLY'
                }
                value="ADMIN OFFICE ONLY"
              />
              <label className="form-label pr-3 m-0">Admin Office only</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'WAREHOUSE'}
                value="WAREHOUSE"
              />
              <label className="form-label pr-3 m-0">Warehouse</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'OTHERS'}
                value="OTHERS"
              />
              <label className="form-label pr-3 m-0">Others</label>
              <input
                className="col-4 custom-input"
                disabled={_.get(formData, 'activity_type') !== 'OTHERS'}
                type="text"
                name="activity_type_others"
                onChange={onChange}
                placeholder="Pls specify"
                value={_.get(formData, 'activity_type_others') || ''}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          {type === 'NEW' && (
            <button
              disabled={creating || !validateForm.response.is_passed}
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            >
              <span className="font-weight-bold">
                {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
              </span>{' '}
            </button>
          )}
          {type === 'EDIT' && (
            <button
              disabled={updating || !validateForm.response.is_passed}
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            >
              <span className="font-weight-bold">
                {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
              </span>{' '}
            </button>
          )}
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

BusinessModal.defaultProps = {
  type: '',
  id: '',
  newBusinessesInfo: {},
};

BusinessModal.propTypes = {
  getNewBusinessesList: PropTypes.instanceOf(Function).isRequired,
  createNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  getVeterinaryFeeList: PropTypes.instanceOf(Function).isRequired,
  veterinaryFeeList: PropTypes.instanceOf(Array).isRequired,
  creating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  id: PropTypes.string,
  type: PropTypes.string,
  newBusinessesInfo: PropTypes.instanceOf(Object),
  updateNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_NEW_BUSINESSES) > -1,
  veterinaryFeeList: _.get(api, `${c.GET_VETERINARY_FEE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_NEW_BUSINESSES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BusinessModal);
